<gpd-multi-step-form
  i18n-title="@@configureProject"
  title="Configure Project"
  [steps]="steps"
  (onCancelClicked)="onCancelClicked()"
  (onFinishClicked)="onFinishClicked()"
  [finishText]="finishText"
>
  <ng-template #phasesTemplate let-validationGroup="validationGroup">
    <app-setup-phases-step
      [phases]="phases"
      [validationGroup]="validationGroup"
      [multiStepForm]="multiStepForm"
      (phasesChange)="onPhasesChange($event)"
    ></app-setup-phases-step>
  </ng-template>
  <ng-template #milestonesTemplate let-validationGroup="validationGroup">
    <app-setup-milestones-step
      [phases]="phases"
      [validationGroup]="validationGroup"
      [multiStepForm]="multiStepForm"
      (phasesChange)="onPhasesChange($event)"
    ></app-setup-milestones-step>
  </ng-template>
  <ng-template #taskPackagesTemplate let-validationGroup="validationGroup">
    <app-setup-task-packages-step
      [phases]="phases"
      [validationGroup]="validationGroup"
      [multiStepForm]="multiStepForm"
      (phasesChange)="onPhasesChange($event)"
    ></app-setup-task-packages-step>
  </ng-template>
  <ng-template #summaryTemplate let-validationGroup="validationGroup">
    <app-setup-summary-step
      [phases]="phases"
      [multiStepForm]="multiStepForm"
      (phasesChange)="onPhasesChange($event)"
    ></app-setup-summary-step>
  </ng-template>
</gpd-multi-step-form>

